import { render, staticRenderFns } from "./alreadyApproved.vue?vue&type=template&id=26c10baf&scoped=true"
import script from "./alreadyApproved.vue?vue&type=script&lang=js"
export * from "./alreadyApproved.vue?vue&type=script&lang=js"
import style0 from "./alreadyApproved.vue?vue&type=style&index=0&id=26c10baf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c10baf",
  null
  
)

export default component.exports